import React from 'react';

import { TypeConfig as CellItemMetaTypeConfig } from '../common/CellItemMeta.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region META

const Tokens = (data) => {
    return [
        Token.getWrappedTokenConfig('List Order Number', Token.ListOrderNumber),
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.Artist.Lifespan),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getEditionInfoTokenConfig(),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
        Token.getDimensionsTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getDimensionsTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing', Token.Inventory.Framed),
        Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
        Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
        Token.getWrappedTokenConfig('Location', Token.Inventory.Location),
        Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price, Token.firstLineCurrencyDifferentToggleOption),
        Token.getCurrencyTokenConfig('Price With Tax', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.PriceWithTax, Token.firstLineCurrencyDifferentToggleOption),
        Token.getAlternatePricesTokenConfig(),
        Token.getWrappedTokenConfig('Price Override', Token.Inventory.DisplayPrice),
        Token.getSoldTokenConfig(),
        Token.getStatusIndicatorTokenConfig(),
        Token.getWrappedTokenConfig('Notes', Token.Notes),
        Token.getWrappedTokenConfig('Private Notes', Token.PrivateNotes),
    ]
};
const TypeConfig = {
    defaultDesign: `
${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("limited":"${Utilities.Inventory.getEditionFormatString('limited')}","unlimited":"${Utilities.Inventory.getEditionFormatString('unlimited')}")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":"","after":"")}`, token: Token.Inventory.AlternateDimensions })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Framed}("before":"","after":"")}`, token: Token.Inventory.Framed })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Location}("before":"","after":"")}`, token: Token.Inventory.Location })}`,
    defaultDesignOrder: Utilities.wrapTextForEditor({ text: `{${Token.ListOrderNumber}("before":"","after":".")}`, token: Token.ListOrderNumber }),
    panel: {
        block: (defaultDesign) => CellItemMetaTypeConfig.panel.block(defaultDesign || TypeConfig.defaultDesign),
        style: CellItemMetaTypeConfig.panel.style
    }
};

// #endregion META

export {
    Tokens,
    TypeConfig
}